<template>
  <div class="checkmark-callouts-dark px-2 grid grid-cols-[auto_auto] gap-y-2.5 justify-between text-xs">
    <CheckmarkCallout
      :text="$t('bundler.savings_off_first_order', { firstSavings: formatCents(store.pricing.firstSavings) })"
    />
    <CheckmarkCallout
      :text="$t('bundler.savings_off_future_orders', { savings: formatCents(store.pricing.savings) })"
    />
    <CheckmarkCallout
      :text="$t('bundler.free_flavor_with_every_box')"
    />
    <CheckmarkCallout :text="$t('bundler.cancel_anytime')" />
    <CheckmarkCallout :text="$t('bundler.free_shipping_in_the_usa')" />
    <CheckmarkCallout :text="$t('bundler.money_back_guarantee')" />
  </div>
</template>

<script setup lang="ts">
import { useBundleStore } from '@/stores'
import { formatCents } from '@/utils'
import { CheckmarkCallout } from '@oatsovernight/storybook'

const store = useBundleStore()
</script>
